<template>
	<b-modal  size="xl" ref="modalAddOrder">
		<template slot="modal-header" slot-scope="{ close }">
			<i class="btn btn-link my-auto" @click="close()"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /></i>
			<h2 class="mx-auto my-auto">{{ $t('action.notifier_centre_stockage') }}</h2>
		</template>
		<template slot="default">
			<div class="form-group">
				<label>{{ $t('monte.reservation.destinataires_notification') }}</label><br>
				<span><i>{{ $t('monte.reservation.info_destinataires_notification') }}</i></span>
				<b-form-checkbox v-model="form.notify_client">{{ $t('monte.reservation.notifier_client') }}</b-form-checkbox>
				<b-form-checkbox v-model="form.notify_cmep">{{ $t('monte.reservation.notifier_cmep') }}</b-form-checkbox>
			</div>

			<div class="form-group">
				<label>{{ $t('monte.reservation.commentaire') }}</label>
				<b-form-textarea
					id="form_comment"
					v-model="form.comment"
					:placeholder="$t('monte.reservation.saisir_commentaire')"
					rows="3"
					max-rows="6"
				></b-form-textarea>
			</div>


			<div class="col-12" v-if="form_error">
				<ErrorAlert :messageI18n="form_error" />
			</div>
		</template>

		<template slot="modal-footer">
			<b-button variant="primary" @click="checkForm()" :disabled="processing">
				<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
				{{ $t('global.sauvegarder') }}
			</b-button>
		</template>
	</b-modal>
</template>

<script type="text/javascript">
	import MonteReservationOrder from "@/mixins/MonteReservationOrder.js"

	export default {
		name: 'ModalAddOrder',
        mixins: [
			MonteReservationOrder
        ],
		data () {
			return {
				processing: false,
                form_error: '',
                form:{
                    comment: '',
                    resa_ids: null,
                    notify_client: false,
                    notify_cmep: false
                }
			}
		},
		methods: {
			async checkForm() {
				this.form_error = ''

				this.processing = true
                const ids = this.form.resa_ids.map(r => r.id)

                return this.notifyOrderExpediteur(ids, this.form.comment, this.form.notify_client, this.form.notify_cmep)
					.then(_ => {
						this.closeModal()
						this.form.comment='';
						this.$emit('ok')
					})
					.catch(_ => {

					})
					.finally(() => {
						this.processing = false
					})

			},
            openModal(resa_ids) {
                this.form.resa_ids = resa_ids;
                this.form.comment = ''
                this.form.notify_client = false
                this.form.notify_cmep = false
                this.form_error = ''
				this.$refs.modalAddOrder.show()
			},
			closeModal() {
				this.$refs.modalAddOrder.hide()
			},
		},
		components: {
			ErrorAlert : () => import('GroomyRoot/components/Alert/ErrorAlert')
		}
	}

</script>